import { render, staticRenderFns } from "./Webhook.vue?vue&type=template&id=612a9ec5&scoped=true"
import script from "./Webhook.vue?vue&type=script&lang=js"
export * from "./Webhook.vue?vue&type=script&lang=js"
import style0 from "./Webhook.vue?vue&type=style&index=0&id=612a9ec5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612a9ec5",
  null
  
)

export default component.exports